<!--
 * @message: 颜色输入组件
 * @Author: Betway<848032671@qq.com>
 * @Github: github
 * @Date: 2020-09-07 17:14:05
 * @FilePath: \mrc-ess-fronted\src\components\MRC_ESS_selectColor.vue
 * @最后编辑: Betway
 * @最后修改时间: 2022-03-07 15:04:23
-->
<template>
  <div class="d-flex justify-start flex-column">
    <v-sheet class="pl-1 d-inline-block text-truncate transparent">
      <span :class="labelClass" v-if="showLabel">
        {{ label }}
      </span>
    </v-sheet>

    <v-menu
      color="white"
      ref="colormenu"
      class="rounded-t-lg"
      :elevation="4"
      offset-y
      disable-keys
      v-model="showMenu"
      transition="slide-y-transition"
      :close-on-content-click="false"
      :close-on-click="true"
    >
      <template v-slot:activator="{ attrs, on, value }">
        <v-select
          ref="select"
          :items="items"
          v-model="selectColor"
          v-on="readonly ? null : on"
          :item-text="itemText"
          :item-value="itemValue"
          v-bind="attrs"
          :dense="dense"
          :height="height ? height : undefined"
          :append-icon="!showMenu ? appendIcon : appendExpandIcon"
          :readonly="true"
          :filled="filled"
          :rules="readonly ? [] : rules"
          :single-line="singleLine"
        >
          <template v-slot:no-data>
            <noContent />
          </template>
          <template v-slot:selection="{ item, index }">
            <!-- 2021-12-17 julia 修改样式 -->
            <!-- <v-chip
              :text-color="selectColor"
              small
              color="transparent"
              class="pl-0 pr-1"
            >
              <i class="material-icons-round" left>fiber_manual_record</i>
              <span class="text--primary">
                {{ $getCommonLangValue(item.text) }}</span
              >
            </v-chip> -->
            <v-chip
              small
              label
              :color="selectColor"
              :style="{ minWidth: '70px', maxWidth: '120px' }"
            />
          </template>
        </v-select>
        <v-sheet
          height="40"
          color="transparent"
          v-on="!readonly ? on : null"
          @click="
            !readonly
              ? () => {
                  $refs['select'].focus();
                  showMenu = true;
                }
              : $refs['select'].focus()
          "
          style="margin-bottom: -40px; z-index: 2"
          v-bind="attrs"
        ></v-sheet>
      </template>
      <!-- 弹出窗口 -->
      <v-container
        fluid
        tile
        style="width: 100%; max-height: 350px"
        class="
          white
          pa-4
          rounded-b-lg
          scroll_content_y
          d-flex
          flex-wrap flex-row
          align-center align-items-center
          text-center
          align-self-center
        "
      >
        <v-sheet
          v-for="(item, index) in items"
          :key="`colors--${index}`"
          height="30"
          width="20%"
          class="d-flex align-center px-1 my-1"
        >
          <v-hover v-slot:default="{ hover }">
            <v-sheet
              :color="item.color"
              height="100%"
              width="100%"
              class="rounded"
              @click="
                selectColor == item.color ? null : (selectColor = item.color)
              "
            >
              <v-sheet
                height="100%"
                width="100%"
                color="rgba(0,0,0,0)"
                class="rounded d-flex flex-row justify-center align-center"
                v-if="hover || selectColor == item.color"
              >
                <span
                  class="material-icons-round"
                  :class="
                    selectColor == item.color ? 'text--primary' : 'white--text'
                  "
                  >check_circle</span
                >
              </v-sheet>
            </v-sheet>
          </v-hover>
        </v-sheet>
      </v-container>
    </v-menu>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  name: "Mrc_color_input",
  model: {
    prop: "value",
    event: "input",
  },
  computed: {
    ...mapGetters(["companyLang", "staticZone", "pageTriger"]),
    isRequire() {
      return this.rules ? (this.rules.length ? true : false) : false;
    },
    labelClass() {
      let cla = " ";
      if (this.isRequire) {
        cla += " mrc_text_require";
      }
      if (this.showMenu) {
        cla += " primary--text";
      } else {
        cla += " text--secondary";
      }
      return cla;
    },
  },
  props: {
    //规则
    rules: {
      default: function () {
        return [];
      },
      type: Array,
    },
    value: { default: "", type: [Number, String] },
    items: {
      default: function () {
        return [];
      },
      type: [String, Array],
    },
    placeholder: { default: "", type: [String, Array] },
    messages: { default: "", type: [String, Array] },
    errorCount: { default: 1, type: Number },
    label: { default: "Color", type: String },
    itemText: { default: "text", type: String },
    itemValue: { default: "color", type: String },
    showLabel: { default: false, type: Boolean },
    hint: { default: "", type: String },
    singleLine: { default: true, type: Boolean },
    filled: { default: true, type: Boolean },
    persistentHint: { default: false, type: Boolean },
    hideDetails: { default: true, type: Boolean },
    canscroll: { default: true, type: Boolean },
    error: { default: false, type: Boolean },
    disabled: { default: false, type: Boolean },
    success: { default: false, type: Boolean },
    loading: { default: false, type: Boolean },
    clearable: { default: false, type: Boolean },
    maxlength: { default: 150, type: [String, Number, Array, Object] },
    flat: { default: false, type: Boolean },
    dense: { default: true, type: Boolean },
    successMsg: { default: "", type: String },
    appendIcon: {
      default: "arrow_drop_down",
      type: [String, Object, Array, Number],
    },
    appendExpandIcon: {
      default: "arrow_drop_up",
      type: [String, Object, Array, Number],
    },
    height: { default: undefined, type: [String, Number] },
    readonly: { default: false, type: Boolean },
  },
  data() {
    return {
      showMenu: false,
      selectColor: "",
      canFocus: false,
      errorMsg: "",
    };
  },
  destroyed() {
    document.onkeydown = undefined; //解绑
  },
  watch: {
    value(val) {
      this.selectColor = val;
    },
    selectColor(val) {
      this.$emit("input", val);
    },
    pageTriger(val) {
      if (val) this.canFocus = true;
    },
  },
  mounted() {
    this.canFocus = false;
  },
  methods: {
    onFocus: function () {
      this.canFocus = true;
    },
  },
};
</script>

